export const CANNOT_FIND_SIMILAR_FLIGHTS_TITLE = "Can’t find a similar flight?";
export const CAN_STILL_REFUND_SUBTITLE =
  "If you can’t find a similar flight, you can still get a refund.";
export const GET_A_REFUND = "Get a Refund";
